import React from "react"

export const MenuToggle = ({ navOpen, children, ...props }) => {
  return <div className="cursor-pointer"{...props}>{children}</div>
}
